import { ComponentRef } from "@angular/core";
import { Observable, Subject } from "rxjs";

import { ModalContainerComponent } from "@lantern/app/common/utils/modals/modal-container.component";
import { ComponentOverlayRef } from "@lantern/app/core/utils/overlays";

/**
 *
 *
 * @export
 * @class ModalRef
 * @template Response
 */
export class ModalRef<Response> {
  /**
   *
   *
   * @readonly
   * @type {Observable<Response>}
   */
  get response(): Observable<Response> {
    return this.subject;
  }

  /**
   *
   *
   * @readonly
   * @type {ComponentRef<ModalContainerComponent<Response>>}
   */
  get containerComponentRef(): ComponentRef<ModalContainerComponent<Response>> {
    return (this.overlayRef as ComponentOverlayRef<
      ModalContainerComponent<Response>
    >).componentRef;
  }

  private subject: Subject<Response> = new Subject<Response>();

  /**
   * Creates an instance of ModalRef.
   * @param {ComponentOverlayRef<ModalContainerComponent<Response>>} overlayRef
   * @param {((err?: any) => Response | Error)} [dismissHandler]
   */
  constructor(
    private overlayRef: ComponentOverlayRef<ModalContainerComponent<Response>>,
    public dismissHandler?: (err?: any) => Response | Error
  ) {}

  /**
   *
   *
   * @param {Response} response
   */
  close(response: Response): void {
    this.subject.next(response);
    this.subject.complete();
  }

  /**
   *
   *
   * @param {*} [err]
   */
  dismiss(err?: any): void {
    if (this.dismissHandler != null) {
      let res: Response | Error = this.dismissHandler(err);
      if (res instanceof Error) {
        this.subject.error(res);
      } else {
        this.subject.next(res);
      }
    } else {
      this.subject.error(err);
    }
    this.subject.complete();
  }

  /**
   * @internal
   */
  destroy(): void {
    this.overlayRef.destroy();
  }
}
